import * as Yup from 'yup'

const AddressSchema = Yup.object({
  address_line_1: Yup.string().required('INPUT.VALIDATION.AUTOLOCATION.ADDRESSLINE1'),
  country: Yup.string().required('INPUT.VALIDATION.AUTOLOCATION.COUNTRY'),
  address_line_2: Yup.string().nullable().optional(),
  city: Yup.string().nullable().optional(),
  state: Yup.string().nullable().optional(),
  postal: Yup.string().nullable().optional(),
  lat: Yup.number().nullable().optional(),
  lng: Yup.number().nullable().optional(),
})

export const RequirementReviewSchema = Yup.object({
  title: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.TITLE'),
  description: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.DESCRIPTION'),
  business_types: Yup.array()
    .of(Yup.string().trim())
    .min(1, 'INPUT.VALIDATION.REQUIREMENT.BUSINESSTYPES')
    .required('INPUT.VALIDATION.REQUIREMENT.BUSINESSTYPES'),
  service_type: Yup.array()
    .of(Yup.string().trim())
    .min(1, 'INPUT.VALIDATION.REQUIREMENT.SERVICETYPES')
    .required('INPUT.VALIDATION.REQUIREMENT.SERVICETYPES'),
  area: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.AREA'),
  area_type: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.AREATYPE'),
  frequency: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.FREQUENCY'),
  duration: Yup.string().trim().required('INPUT.VALIDATION.REQUIREMENT.DURATION'),
  start_date: Yup.date()
    .typeError('INPUT.VALIDATION.REQUIREMENT.STARTDATE')
    .required('INPUT.VALIDATION.REQUIREMENT.STARTDATE'),
  end_date: Yup.date()
    .nullable()
    .optional()
    .when('start_date', (start: any, schema: any) =>
      start
        ? schema.test('end-after-start', 'INPUT.VALIDATION.REQUIREMENT.ENDDATE.AFTERSTART', (end) => {
            if (!end) return true
            return new Date(end).getTime() >= new Date(start).getTime()
          })
        : schema
    ),
  budget: Yup.string()
    .required('INPUT.VALIDATION.REQUIREMENT.BUDGET')
    .test('is-number','INPUT.VALIDATION.REQUIREMENT.BUDGET.NUMBER', (v) => {
      if (v === undefined || v === null || v === '') return false
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n)
    })
    .test('min-amount','INPUT.VALIDATION.REQUIREMENT.BUDGET.MIN', (v) => {
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n) && n >= 100
    }),
  status: Yup.mixed()
    .oneOf(['open','pause','closed','shortlisted','under_consideration','awarded'], 'INPUT.VALIDATION.REQUIREMENT.STATUS')
    .required('INPUT.VALIDATION.REQUIREMENT.STATUS'),
  address: AddressSchema.required('INPUT.VALIDATION.REQUIREMENT.ADDRESS'),
  documents_required: Yup.array()
    .of(Yup.object({ doc_name: Yup.string().trim().min(1, 'INPUT.VALIDATION.REQUIREMENT.DOCSREQ.ITEM') }))
    .nullable()
    .optional(),
  attachments: Yup.array()
    .of(
      Yup.object({
        url: Yup.string().trim().required(),
        name: Yup.string().trim().required(),
      })
    )
    .nullable()
    .optional(),
})

export type RequirementReviewSchemaType = Yup.InferType<typeof RequirementReviewSchema>
